import {Routes} from '@angular/router';
import {AdminComponent} from './layout/admin/admin.component';
import {AuthComponent} from './layout/auth/auth.component';


export const AppRoutes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'authentication/login',
        pathMatch: 'full'
      },
      {
        path: 'authentication',
        loadChildren: './pages/authentication/authentication.module#AuthenticationModule'
      },
      {
        path: 'recuperar_contrasenia',
        loadChildren: './pages/authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: './pages/dashboard/dashboard-default/dashboard-default.module#DashboardDefaultModule'
      },
      {
        path: 'correo',
        loadChildren: './pages/email/email.module#EmailModule'
      },
      {
        path: 'usuarios',
        children: [
          {
            path: 'institucion',
            loadChildren: './pages/configuracion/usuarios/usuarios.module#UsuariosModule'
          },
        ]
      },
      {
        path: 'perfil',
        loadChildren: './pages/configuracion/usuarios/usuarios.module#UsuariosModule'
      },
      {
        path: 'reportes',
        children: [
          {
            path: 'listados',
            loadChildren: './pages/reportes/reportes.module#ReportesModule'
          },

        ]
      },
      {
        path: 'calificaciones',
        children: [
          {
            path: 'reporte_calificacion',
            loadChildren: './pages/registro-calificacion/calificaciones.module#CalificacionesModule'
          },
        ]
      },
      {
        path: 'reporte_calificacion',
        loadChildren: './pages/registro-calificacion/calificaciones.module#CalificacionesModule'
      },

      {
        path: 'docentes',
        loadChildren: './pages/administrativo/docentes/docentes.module#DocentesModule'
      },
      {
        path: 'inscripciones_matriculas',
        children: [
          {
            path: 'matricula',
            loadChildren: './pages/procesos-academicos/matriculas/matriculas.module#MatriculasModule'
          },
          /*{
            path: 'transporte',
            loadChildren: './pages/administrativo/transporte/transporte.module#TransporteModule'
          },*/
          {
            path: 'asignar_curso',
            loadChildren: './pages/procesos-academicos/asignacion-cursos/asignacion-cursos.module#AsignacionCursosModule'
          },
          {
            path: 'estudiantes',
            loadChildren: './pages/procesos-academicos/matriculas/matriculas.module#MatriculasModule'
          },
          {
            path: 'pase_anio',
            loadChildren: './pages/procesos-academicos/pase-anio/pase-anio.module#PaseAnioModule'
          },
          {
            path: 'importar',
            loadChildren: './pages/procesos-academicos/importar-fotos/importar-fotos.module#ImportarFotosModule'
          }
        ]
      },
      {
        path: 'control_administrativo',
        children: [
          {
            path: 'parametros_globales',
            children: [
                {
                  path: 'docentes',
                  loadChildren: './pages/administrativo/docentes/docentes.module#DocentesModule'
                },
                {
                  path: 'asignaturas',
                  loadChildren: './pages/administrativo/asignaturas/asignaturas.module#AsignaturasModule'
                },
                {
                  path: 'areas',
                  loadChildren: './pages/administrativo/asignaturas-areas/asignaturas-areas.module#AsignaturasAreasModule'
                },

              ]
          },
          {
            path: 'parametros_anuales',
            children: [
              {
                path: 'pensum',
                loadChildren: './pages/administrativo/pensum/pensum.module#PensumModule'
              },
              {
                path: 'actividades',
                loadChildren: './pages/administrativo/actividades/actividades.module#ActividadesModule'
              },
              {
                path: 'reportes',
                loadChildren: './pages/administrativo/reportes/reportes.module#ReportesModule'
              }

            ]
          },

          {
            path: 'procesos_academicos',
            children: [
              {
                path: 'inscripciones',
                loadChildren: './pages/procesos-academicos/inscripciones/inscripciones.module#InscripcionesModule'
              },
              {
                path: 'matriculas',
                loadChildren: './pages/procesos-academicos/matriculas/matriculas.module#MatriculasModule'
              }
            ]
          },
        ]
      },

      {
        path: 'matricula_secretaria',
        loadChildren: './pages/procesos-academicos/matriculas/matriculas.module#MatriculasModule'
      },
      {
        path: 'colecturia',
        children: [
          {
            path: 'cobranza',
            loadChildren: './pages/colecturia/colecturia.module#ColecturiaModule'
          },
          {
            path: 'cartera',
            loadChildren: './pages/colecturia/cartera/cartera.module#CarteraModule'
          },
        ]
      },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts